import {Component, Inject, OnInit, ViewContainerRef} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../shared/services/user/user.service";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Overlay} from "angular2-modal";
import {DOCUMENT} from "@angular/platform-browser";
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {validateEmail} from "../../shared/validators/validate-email";
import {UUID} from "angular2-uuid";
import {AuthService} from "../../shared/security/auth.service";
import {Code} from "../../shared/model/code";



@Component({
  selector: 'app-user-send-code',
  templateUrl: './user-send-code.component.html',
  styleUrls: ['./user-send-code.component.css']
})
export class UserSendCodeComponent implements OnInit {
  roles: string[] = ['Admin - Bill Pay','Admin','Monitor'];

  form:FormGroup;

   accessCode:string;
   currentRestaurantName: string;
  private restaurantId:string;
  private currentUserId:string;
  private code: Code;

   selectedRole:string;
  private selectorIsClicked:boolean;

  private logedUserId:string;
  private logedInSysID:string;
  private logedRole:string;
  private adminDbAdmin:boolean;

  private userId: any;


  constructor(

    private route:              ActivatedRoute,
    private formBuilder:        FormBuilder,
    private restaurantservice:  RestaurantService,
    private authService:        AuthService,
    private userService:        UserService,
    public  modal:              Modal,
    private router:             Router,

    overlay:                    Overlay,
    vcRef:                      ViewContainerRef,
    @Inject(DOCUMENT) private document,


  ) {
    overlay.defaultViewContainer = vcRef;

    this.form = this.formBuilder.group({
      email:['',[Validators.required, validateEmail]],
      confirmEmail:['',[Validators.required]],
      role:['',Validators.required]
    });

    this.selectorIsClicked = false;

    this.code = Object.assign({});

  }

  ngOnInit() {



    let myRoute = this.route.snapshot;
    this.restaurantId = myRoute.params['id'];

    const user$ = this.userService.getUser( this.authService.getUid());

    user$
      .subscribe( user => {
        this.currentUserId = user.$key;


        const rRestaurant$ = this.restaurantservice.getRestaurantByKey(this.restaurantId);
        rRestaurant$
          .subscribe((restaurant)=>{this.currentRestaurantName = restaurant.restaurant});


        this.select("Monitor");

        const relation = this.userService.getUserRole(this.restaurantId,this.currentUserId);

        relation
          .subscribe((thisRelations) => {


            this.logedInSysID = this.authService.getUid();
            this.currentUserId = this.logedInSysID;

            const logedUser$ = this.userService.getUser(this.logedInSysID);
            logedUser$
              .subscribe((user)=>{
                this.logedUserId = user.$key;
                const logRelation = this.userService.getUserRole(this.restaurantId,this.logedUserId);
                logRelation
                  .subscribe((logedRelation)=>{
                    this.logedRole = logedRelation[0].$value;
                    switch(this.logedRole) {
                      case "waiter": {
                        this.roles = ["Monitor"]
                        break;
                      }
                      case "admin-bp": {
                        this.roles = ['Admin - Bill Pay','Admin','Monitor'];
                        break;
                      }
                      case "admin": {
                        this.roles = ['Admin','Monitor'];
                        break;
                      }
                      default: {
                        this.roles = ["Monitor"];
                        break;
                      }
                    }
                    this.adminDbAdmin = this.selectedRole == 'admin-db';
                  });
              })
          });





      });



    this.accessCode = UUID.UUID();



/*
    let partOfUuid = this.accessCode.substr(this.accessCode.length - 6);

    this.form.controls['email'].setValue( partOfUuid+"@luissalcedo.com");
    this.form.controls['confirmEmail'].setValue( partOfUuid+"@luissalcedo.com");
*/








  }

  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  sendCode(){


    const isValid = this.form.valid;


    if (isValid){

      this.code.adminUser = '';

      if (this.currentUserId){
        this.code.adminUser  = this.currentUserId;
      }

      this.code.restaurantId = this.restaurantId;
      this.code.code = this.accessCode;
      this.code.userId = '';
      this.code.userEmail = this.form.value.email;
      this.code.createdDateTime =  new Date().toISOString();
      this.code.usedDateTime = '';
      this.code.emailSent = false;
      this.code.restaurant = this.currentRestaurantName;
      this.code.userRole = this.selectedRole;
      this.code.userInRecord = false;



      const emailExist$ = this.userService.userByEmailExist(this.code.userEmail)
      emailExist$.first()
        .subscribe((userExist)=>{
          if (userExist == 1){
            const user$ = this.userService.getUserByEmail(this.code.userEmail)
            user$.first()
              .subscribe((thisUser)=>{
                this.userService.getRestaurantsforUser(thisUser.$key)
                  .subscribe((restaurants)=> {
                    let userExistVar = false;
                    restaurants.forEach((innerElement) => {
                      if (innerElement.$key == this.restaurantId) {
                        if (!userExistVar) {
                          userExistVar = true
                        }
                      }
                    })
                    if(userExistVar){
                      this.userExistMessage();
                    }
                    else
                    {
                      this.code.userInRecord = true;
                      this.sendingCode();
                    }
                  })
              })
          }else{
            this.sendingCode();
          }
        });

    } else {
      this.showErrors();
    }

  }







  sendingCode(){
    const sendingCode$ = this.restaurantservice.enterCode(this.code);
    sendingCode$
      .subscribe(()=> {
        this.emailSentDialog(this.code.userEmail);
      },err => this.messageIt('Error sending Code',err))


  }

  userExistMessage(){


    this.modal.confirm()
      .size('lg')
      .showClose(true)
      .title("User Already registered")
      .body(this.code.userEmail+' already exist for '+this.currentRestaurantName)
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => { return dialog.result })
      .then((result: any) => { this.moveOn() })
      .catch((err: any) => this._cleanup());

  }





  emailSentDialog(userEmail){
    this.modal.confirm()
      .size('lg')
      .isBlocking(true)
      .showClose(true)
      .keyboard(27)
      .title('Registration Email sent')
      .body('A registration link was sent to '+userEmail)
      .cancelBtn('Send Another Code')
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => {return dialog.result; })
      .then((result: any) => { this.moveOn()})
      .catch((err: any) => this._cleanup())

    ;
  }

  _cleanup(){

    this.form.controls['email'].setValue("");
    this.form.controls['confirmEmail'].setValue("");
    this.accessCode = UUID.UUID();
    this.form.markAsPristine();
  }

  moveOn(){
    this.router.navigate(['/restaurants/'+this.restaurantId])
  }


  showemailEmailSentMessage(){
    return new Promise( (resolve, reject) => {
      this.messageIt('Registration Email sent','A registration link was sent to '+this.code.userEmail+'!');
      // console.debug("Moving On");
    });
  }



  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
    if (this.selectedRole === "Select a role"){
      this.selectorIsClicked = true;
      this.form.controls['role'].markAsDirty();
    }

  }

  itMatch(){
    const val = this.form.value;
    const itMatch = val.email == val.confirmEmail;
    return itMatch;
  }

  messageIt(titleP: string, messageP: string) {

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }

  printOpening() {

    this.selectorIsClicked = true;
  }

  printClosing() {


    this.selectorIsClicked = true;
  }

  clicked(){

  }


  cancel(){

       this.router.navigate(['/restaurants/'+this.restaurantId])

  }

  select(selectedRole:string) {

    this.selectedRole = selectedRole;
    this.form.controls['role'].setValue(selectedRole);

  }

  showSelectorError(){

    const showError = this.selectedRole == "Select a role" && this.selectorIsClicked;
    return showError;

  }

  setBlank(){

    this.form.reset();
    this.selectorIsClicked = false;

  }

  reset() {
    this.form.reset();
  }

  get valid(){
    return this.form.valid;
  }

  get value(){
    return this.form.value;
  }


}



// WEBPACK FOOTER //
// ./src/app/user/user-send-code/user-send-code.component.ts